import {
  SET_USER_INFO,
  RESET_USER_INFO,
  SET_WODS,
} from "../../actions/types/types";

const initState = {
  user: {},
  tempMobileToken: null,
  wods: [],
};

const UserReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        user: action.payload.data,
      };
    case RESET_USER_INFO:
      return { ...state, user: {} };
    case SET_WODS:
      return {
        ...state,
        wods: action.payload.data,
      };

    case "SET_TEMP_MOBILE_TOKEN": {
      return {
        ...state,
        tempMobileToken: action.payload.data,
      };
    }
    default:
      return { ...state };
  }
};

export default UserReducer;
